import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { Mascot } from './Mascot';
import { LeafPatchBackground } from './LeafPatchBackground';
import { homeHero } from '../../data/home';
import { business } from '../../data/business';
const ease: [number, number, number, number] = [0.22, 1, 0.36, 1];
export function HomeHero() {
  return <section id="home-hero" aria-labelledby="home-hero-title" className="relative isolate w-full overflow-hidden bg-[#78A942]" data-id="element-176" data-mp="2wvg34pu6qxm1">
      <LeafPatchBackground data-id="element-177" data-mp="2n4bsu3fgg0xj" />

      <div className="mx-auto flex max-w-7xl flex-col items-center gap-10 px-5 py-16 sm:px-8 md:py-20 lg:flex-row-reverse lg:justify-between lg:gap-16 lg:py-24" data-id="element-178" data-mp="2n3adhmreosa0">
        <div className="w-full lg:w-[42%]" data-id="element-179" data-mp="3fszhm8zex8fu">
          <Mascot src={homeHero.mascotImage} alt={homeHero.mascotAlt} data-id="element-180" data-mp="3fs7jaqefkwlv" />
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease
      }} className="w-full text-center lg:w-[55%] lg:text-left" data-id="element-181" data-mp="3kjza921i14cj">
          <h1 id="home-hero-title" className="font-display text-5xl font-medium leading-[1.02] tracking-tight text-white [text-shadow:0_2px_16px_rgba(0,0,0,0.45)] sm:text-6xl lg:text-7xl" data-id="element-182" data-mp="jxpda5qhrsze">
            {homeHero.headline}
          </h1>
          <div className="mt-10 flex justify-center lg:justify-start" data-id="element-183" data-mp="17kxfufwjcnxq">
            <Link to={business.quoteHref} className="inline-flex h-14 items-center justify-center gap-2 rounded-full bg-[#E3C77F] px-8 text-[13px] font-bold uppercase tracking-[0.08em] text-forest-900 shadow-[0_12px_30px_-12px_rgba(0,0,0,0.7)] transition-colors hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-olive" data-id="element-184" data-mp="12mm41zmok3cv">
              Get Your Quote <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-185" data-mp="3edznlxbko36s" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}